import * as yup from 'yup'
import moment from 'moment'

export const assignPendValidationSchema = yup.object({
  comments: yup.string().when('requireComment', {
    is: false,
    then: (schema: any) => schema.notRequired(),
    otherwise: (schema: any) => schema.required('Comments are required'),
  }),
  pendDate: yup
    .string()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value
    })
    .when('isPend', {
      is: true,
      then: (schema: any) =>
        schema
          .required('Pend date requires a valid date')
          .test(
            'is-not-past',
            'Pend date cannot be in the past',
            (value: string | null) => {
              if (!value) return false
              const parsed = moment(value, 'YYYY-MM-DD', true)
              return parsed.isSameOrAfter(moment(), 'day')
            }
          ),
      otherwise: (schema: any) => schema.notRequired(),
    }),
  pendNote: yup.string().when('isPend', {
    is: false,
    then: (schema: any) => schema.notRequired(),
    otherwise: (schema: any) => schema.required('Pend note is required'),
  }),
  assignUser: yup.string().when('isAssign', {
    is: false,
    then: (schema: any) => schema.notRequired(),
    otherwise: (schema: any) => schema.required('Assign user is required'),
  }),
  assignDueDate: yup
    .string()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value
    })
    .when('isAssign', {
      is: true,
      then: (schema: any) =>
        schema
          .notRequired()
          .test(
            'is-not-past',
            'Due Date cannot be in the past',
            (value: string | null) => {
              if (!value) return true
              const parsed = moment(value, 'YYYY-MM-DD', true)
              return parsed.isSameOrAfter(moment(), 'day')
            }
          )
          .test('is-valid-date', 'Due Date must be a valid date', () => {
            const dateInput = document.getElementById(
              'assignDueDate'
            ) as HTMLInputElement | null

            if (dateInput && dateInput.value === '') {
              if (dateInput.validity.badInput) {
                return false
              }
            } else {
              return true
            }

            return true
          }),
      otherwise: (schema: any) => schema.notRequired(),
    }),
})
